import { createApi } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl.jsx";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const containerApi = createApi({
  reducerPath: "containerApi",
  baseQuery,
  tagTypes: ["Container"],
  endpoints: (builder) => ({
    
    getContainerByMasterId: builder.query({
      query: ({id}) => `export/container/${id}`,
      transformResponse: (response) => {
        const data = response?.data?.map((container) => ({
          ...container,
          id: container.exportContainerId,
        }));
        return data;
      },
      providesTags: ["Container"],
    }),

    updateContainer: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `export/container/${id}/${subId}`,
        method: "PUT",
        body: { container:data },
      }),
      invalidatesTags: ["Container"],
    }),

    deleteContainer: builder.mutation({
      query: ({ id }) => ({
        url: `export/container/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Container"],
    }),

    createContainer: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/container/${id}`, 
        method: "PUT",
        body: { container:data },
      }),
      invalidatesTags: ["Container"],
    }),

  }),
});

export const {
  useLazyGetContainerByMasterIdQuery,
  useUpdateContainerMutation,
  useDeleteContainerMutation,
  useCreateContainerMutation,
} = containerApi;

